import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7a3063c6&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detail.vue?vue&type=style&index=1&id=7a3063c6&lang=scss&scoped=true&"
import style2 from "./detail.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./detail.vue?vue&type=style&index=3&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3063c6",
  null
  
)

export default component.exports